// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4025":"css/app.6899","6264":"css/admin-app.6899"}[chunkId] + ".css";
};